import types from '@/vuex/busca-documentos/actions-types'
import documentos from '@/utils/documentos'
import autuacao from '@/utils/autuacao'

const actions = {
  'SHOW_SNACKBAR': ({ commit }, payload) => {
    commit(types.SHOW_SNACKBAR, { snackbarType: payload.snackbarType, snackbarText: payload.snackbarText }, {root: true})
  },
  [types.EXIBIR_DIALOG_INTERESSADO]: ({ commit }) => {
    commit(types.EXIBIR_DIALOG_INTERESSADO)
  },
  [types.ESCONDER_DIALOG_INTERESSADO]: ({ commit }) => {
    commit(types.ESCONDER_DIALOG_INTERESSADO)
  },
  [types.EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO]: ({ commit }) => {
    commit(types.EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO)
  },
  [types.ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO]: ({ commit }) => {
    commit(types.ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO)
  },

  [types.SET_TIPO_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SET_TIPO_INTERESSADO, payload)
  },
  [types.SET_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SET_INTERESSADO, payload)
  },
  [types.SET_LISTA_INTERESSADOS]: ({ commit }, payload) => {
    commit(types.SET_LISTA_INTERESSADOS, payload)
  },
  [types.SET_TIPO_RESPONSAVEL_TRAMITACAO]: async ({ commit }, payload) => {
    commit(types.SET_TIPO_RESPONSAVEL_TRAMITACAO, payload)
  },
  [types.SET_RESPONSAVEL_TRAMITACAO]: async ({ commit }, payload) => {
    commit(types.SET_RESPONSAVEL_TRAMITACAO, payload)
  },
  [types.SET_LISTA_RESPONSAVEL_TRAMITACAO]: ({ commit }, payload) => {
    commit(types.SET_LISTA_RESPONSAVEL_TRAMITACAO, payload)
  },
  [types.SET_LISTA_DOCUMENTOS]: ({ commit }, payload) => {
    commit(types.SET_LISTA_DOCUMENTOS, payload)
  },

  [types.GET_LISTA_TODOS_TIPOS_DOCUMENTO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documentos'}, {root: true})
    try {
      const response = await documentos.getTodosTiposDocumento()
      commit(types.SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documentos'}, {root: true})
    }
  },

  [types.GET_LISTA_TIPOS_INTERESSADO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de interessados'}, {root: true})
    try {
      const response = await autuacao.getListaTipoInteressado()
      let lista = []
      response.data.forEach(tipo => {
        lista.push({id: tipo, descricao: tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ')})
      })
      commit(types.SET_LISTA_TIPO_INTERESSADO, { listaTiposInteressado: lista })
      return lista
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de interessados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de interessados'}, {root: true})
    }
  },

  [types.GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de responsáveis tramitação'}, {root: true})
    try {
      const response = await autuacao.getListaTipoResponsavelTramitacao()
      let lista = []
      response.data.forEach(tipo => {
        let descricao = ''
        if (tipo === 'COMISSAO') {
          descricao = 'Comissão'
        } else if (tipo === 'SERVIDOR') {
          descricao = 'Pessoa específica'
        } else {
          descricao = tipo.charAt(0) + tipo.slice(1).toLowerCase().split('_').join(' ')
        }
        lista.push({id: tipo, descricao: descricao})
      })
      commit(types.SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO, { listaTiposResponsavelTramitacao: lista })
      return lista
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de responsáveis tramitação' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de responsáveis tramitação'}, {root: true})
    }
  },

  [types.GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando unidades de procedência'}, {root: true})
    try {
      const response = await documentos.getListaUnidadesProcedenciaConsulta()
      commit(types.SET_LISTA_UNIDADES_PROCEDENCIA, { listaUnidadesProcedencia: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar unidades de procedência' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando unidades de procedência'}, {root: true})
    }
  },

  [types.GET_LISTA_SERVIDORES_PROCEDENCIA]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando servidores das unidades de procedência'}, {root: true})
    try {
      const response = await documentos.getListaServidoresProcedencia()
      response.data.unshift(
        {header: 'Escolher Todos'},
        {codigo: '0', cpf: '0', id: -1, nome: 'TODOS', situacao: 'Indefinida'},
        { divider: true },
        {header: 'Escolher um Servidor'}
      )
      commit(types.SET_LISTA_SERVIDORES_PROCEDENCIA, { listaServidoresProcedencia: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar servidores das unidades de procedência' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando servidores das unidades de procedência'}, {root: true})
    }
  },

  [types.INICIALIZAR_DADOS_BUSCA_DOCUMENTOS]: async ({ commit, dispatch }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Carregando busca de documentos.'}, {root: true})
    commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: [] })
    commit(types.SET_INTERESSADO, { interessado: undefined })
    commit(types.SET_RESPONSAVEL_TRAMITACAO, { responsavelTramitacao: undefined })

    var promises = []

    promises.push(dispatch(types.GET_LISTA_TODOS_TIPOS_DOCUMENTO))
    promises.push(dispatch(types.GET_LISTA_TIPOS_INTERESSADO))
    promises.push(dispatch(types.GET_LISTA_TIPOS_RESPONSAVEL_TRAMITACAO))
    promises.push(dispatch(types.GET_LISTA_UNIDADES_PROCEDENCIA_CONSULTA))

    try {
      await Promise.all(promises)
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.statusText }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Carregando busca de documentos.'}, {root: true})
    }
  },

  [types.GET_LISTA_TIPOS_DOCUMENTO_AUTORIZADOS]: async ({ commit }) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documento autorizados'}, {root: true})
    try {
      const response = await documentos.getTiposDocumentoAutorizados()
      commit(types.SET_LISTA_TIPOS_DOCUMENTO, { listaTiposDocumento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar tipos de documento autorizados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando tipos de documento autorizados'}, {root: true})
    }
  },

  [types.GET_LISTA_INTERESSADOS]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando interessados.'}, {root: true})
    try {
      commit(types.SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: [] })
      const response = await autuacao.getListaEntidadeInteressada(payload.tipoInteressado, payload.tipoBusca, payload.nome, payload.codigo, payload.somenteAtivos)
      commit(types.SET_LISTA_INTERESSADOS, { listaEntidadeInteressada: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os interessados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando interessados.'}, {root: true})
    }
  },

  [types.GET_LISTA_RESPONSAVEL_TRAMITACAO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando responsáveis tramitação.'}, {root: true})
    try {
      commit(types.SET_LISTA_RESPONSAVEL_TRAMITACAO, { listaEntidadeResponsavelTramitacao: [] })
      const response = await autuacao.getListaEntidadeResponsavelTramitacao(payload.tipoResponsavelTramitacao, payload.tipoBusca, payload.nome, payload.codigo)
      commit(types.SET_LISTA_RESPONSAVEL_TRAMITACAO, { listaEntidadeResponsavelTramitacao: response.data })
      return response.data
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar os responsáveis tramitação' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando responsáveis tramitação.'}, {root: true})
    }
  },

  [types.GET_INTERESSADO_POR_CODIGO]: async ({ commit }, payload) => {
    if (payload.idTipoInteressado && !payload.idInteressado) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não é possível buscar um interessado sem definir seu tipo' }, {root: true})
    } else {
      commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando interessado.'}, {root: true})
      try {
        const response = await documentos.getInteressadoPorId(payload.idTipoInteressado, payload.idInteressado)
        if (response.data.length === 1) {
          return response.data[0]
        } else if (response.data.length === 0) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Interessado não encontrado' }, {root: true})
          return undefined
        } else if (response.data.length > 1) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Múltiplos interessados encontrados' }, {root: true})
          return undefined
        }
      } catch (error) {
        console.log(error)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o interessado' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando interessado.'}, {root: true})
      }
    }
  },

  [types.GET_RESPONSAVEL_TRAMITACAO_POR_CODIGO]: async ({ commit }, payload) => {
    if (payload.idTipoResponsavelTramitacao && !payload.idResponsavelTramitacao) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não é possível buscar um responsável tramitações sem definir seu tipo' }, {root: true})
    } else {
      commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando responsável tramitações.'}, {root: true})
      try {
        const response = await documentos.getResponsavelTramitacaoPorId(payload.idTipoResponsavelTramitacao, payload.idResponsavelTramitacao)
        if (response.data.length === 1) {
          return response.data[0]
        } else if (response.data.length === 0) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Responsável tramiações não encontrado' }, {root: true})
          return undefined
        } else if (response.data.length > 1) {
          commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Múltiplos responsáveis tramitações encontrados' }, {root: true})
          return undefined
        }
      } catch (error) {
        console.log(error)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível encontrar o responsável tramitações' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: 'Buscando responsável tramitações.'}, {root: true})
      }
    }
  },

  [types.GET_LISTA_DOCUMENTOS]: async ({ commit }, payload) => {
    if ((payload.dataEnvioInicio && !payload.dataEnvioFim) || (!payload.dataEnvioInicio && payload.dataEnvioFim)) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data de tramitação, é necessário selecionar tanto a data de tramitação inicial quanto a data de tramitação final' }, {root: true})
      throw new Error('Ao selecionar uma data de tramtiação, é necessário selecionar tanto a data de criação inicial quanto a data de tramitação final')
    }
    if ((payload.dataCriacaoInicio && !payload.dataCriacaoFim) || (!payload.dataCriacaoInicio && payload.dataCriacaoFim)) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar uma data de criação, é necessário selecionar tanto a data de criação inicial quanto a data de criação final' }, {root: true})
      throw new Error('Ao selecionar uma data de criação, é necessário selecionar tanto a data de criação inicial quanto a data de criação final')
    }

    if ((payload.tipoInteressado && !payload.interessado) || (!payload.tipoInteressado && payload.interessado)) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao selecionar um tipo de interessado, é necessário selecionar também uma entidade interessada' }, {root: true})
      throw new Error('Ao selecionar um tipo de interessado, é necessário selecionar também uma entidade interessada')
    }

    if (payload.resumoAssunto && payload.resumoAssunto.length > 0 && payload.resumoAssunto.length < 3) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'O campo resumo de assunto deve conter no mínimo três caracteres' }, {root: true})
      throw new Error('O campo resumo de assunto deve conter no mínimo três caracteres')
    }

    if (payload.resumoAssunto && !((payload.dataCriacaoInicio && payload.dataCriacaoFim) || (payload.dataEnvioInicio && payload.dataEnvioFim))) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Ao buscar pelo resumo do assunto, é necessário preencher completamente o filtro de data de criação ou de tramitação' }, {root: true})
      throw new Error('Ao buscar pelo resumo do assunto, é necessário preencher completamente pelo menos um dos filtros de data')
    }

    if (payload.usuario) {
      if (!payload.numeroDocumento &&
          !((payload.dataCriacaoInicio && payload.dataCriacaoFim) || (payload.dataEnvioInicio && payload.dataEnvioFim)) &&
          !payload.tipoInteressado &&
          !payload.interessado &&
          !payload.tipoResponsavelTramitacao &&
          !payload.responsavelTramitacao &&
          !payload.servidoresProcedencia) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado, um responsavel por tramitações ou um servidor lotado em unidades de procedência do usuário' }, {root: true})
        throw new Error('Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado, um responsavel por tramitações ou um servidor lotado em unidades de procedência do usuário')
      }
    } else {
      if (!payload.numeroDocumento &&
          !((payload.dataCriacaoInicio && payload.dataCriacaoFim) || (payload.dataEnvioInicio && payload.dataEnvioFim)) &&
          !payload.tipoInteressado && !payload.interessado &&
          !payload.tipoResponsavelTramitacao && !payload.responsavelTramitacao) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado ou um responsavel por tramitações' }, {root: true})
        throw new Error('Defina pelo menos uma seleção de filtros: o número do documento, um dos filtros de data, um interessado ou um responsavel por tramitações')
      }
    }
    commit(types.SET_BUSCANDO_DOCUMENTOS, { buscandoDocumentos: true })
    try {
      commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: [] })
      const response = await documentos.getListaDocumentos(payload)
      const length = response.data.length
      for (let i = 0; i < length; i++) {
        if (response.data[i].estado && response.data[i].estado['32002'] === 3) {
          response.data[i].tipo = response.data[i].tipo + ' (Digitalizado)'
        }
      }
      commit(types.SET_LISTA_DOCUMENTOS, { listaDocumentos: response.data })
      return response.data
    } catch (error) {
      console.log(error)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar documentos' }, {root: true})
      throw error
    } finally {
      commit(types.SET_BUSCANDO_DOCUMENTOS, { buscandoDocumentos: false })
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/busca-documentos/actions.js